import authAxios from "../axios-instance/authAxios";

const MAIN_API_HOST = process.env.REACT_APP_MAIN_API_HOST;

export const PostApi = {
    getPosts,
    getPost,
    createPost,
    updatePost,
    deletePost,
}

// 내 글 목록 (scope: 'OWNER' → 임시저장 포함 + 그룹별 개수)
async function getPosts({ headers, params }) {
    return await authAxios.get(`${MAIN_API_HOST}/v2/public/posts`, {
        headers: headers,
        params: params,
    })
}

async function getPost({ headers, id }) {
    return await authAxios.get(`${MAIN_API_HOST}/v2/public/posts/${id}`, {
        headers: headers,
    })
}

async function createPost({ headers, body }) {
    return await authAxios.post(`${MAIN_API_HOST}/v2/public/posts`, body, {
        headers: headers,
    })
}

async function updatePost({ headers, id, body }) {
    return await authAxios.patch(`${MAIN_API_HOST}/v2/public/posts/${id}`, body, {
        headers: headers,
    })
}

async function deletePost({ headers, id }) {
    return await authAxios.delete(`${MAIN_API_HOST}/v2/public/posts/${id}`, {
        headers: headers,
    })
}
